import { Container } from "./style";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { Link } from "react-router-dom";
import api from "../../services/api";

export function HomeLogged() {
  const token = JSON.parse(localStorage.getItem("token"));
  const jwtToken = jwtDecode(token.access_token);
  const [userName, setUserName] = useState();
  const [userLastName, setUserLastName] = useState();
  const [profession, setProfession] = useState();
  const [loading, setLoading] = useState(true);
  const id = jwtToken.idExternal;
  const cpf = localStorage.getItem("cpf");

  useEffect(() => {
    async function getUser() {
      const responseApi = await api.get(`/users?id=${id}&cpf=${cpf}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      });
      const occupation = responseApi.data.occupation.occupation.occupation;
      const otherOccupation =
        responseApi.data.occupation.occupation.otherOccupation;
      setUserName(responseApi.data.firstName);
      setUserLastName(responseApi.data.lastName);
      setProfession(occupation ? occupation : otherOccupation);
      setLoading(false);
    }
    getUser();
  }, [cpf, id, token?.access_token]);

  return (
    <>
      <Container>
        <div className="page-header">
          <Skeleton paragraph={{ rows: 1 }} loading={loading} active>
            <h2 className="user-name">{userName}</h2>
            <h2 className="user-last-name">{userLastName}</h2>
            <Link to="/edit-user">
              <button className="btn-user-edit">Editar dados</button>
            </Link>
            <h3 className="user-profession">{profession}</h3>
          </Skeleton>
        </div>
        <h1 className="page-title">Em breve novidades para você!</h1>
      </Container>
    </>
  );
}
